import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../static/css/AdminSchedule.css";

function AdminSchedule() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [event, setEvent] = useState("");
  const [description, setDescription] = useState("");
  const [schedules, setSchedules] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      const response = await fetch("https://backend.skpandco.in/schedule");
      const data = await response.json();
      setSchedules(data);
    } catch (error) {
      console.error("Error fetching schedules:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this schedule?")) {
      try {
        const response = await fetch(`https://backend.skpandco.in/schedule/delete/${id}`, {
          method: "DELETE",
        });
        if (response.ok) {
          alert("Schedule deleted successfully");
          fetchSchedules();
        } else {
          alert("Failed to delete schedule");
        }
      } catch (error) {
        console.error("Error deleting schedule:", error);
      }
    }
  };

  const handleEdit = (schedule) => {
    setIsEditing(true);
    setEditId(schedule.id);
    setEvent(schedule.event);
    setDescription(schedule.description);
    setSelectedDate(schedule.date ? new Date(schedule.date) : null);
    
    // Time parsing (assuming HH:mm:ss format from MySQL)
    if (schedule.time) {
      const [hours, minutes] = schedule.time.split(":");
      const time = new Date();
      time.setHours(parseInt(hours), parseInt(minutes), 0);
      setSelectedTime(time);
    } else {
      setSelectedTime(null);
    }
    
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setEvent("");
    setDescription("");
    setSelectedDate(null);
    setSelectedTime(null);
    setIsEditing(false);
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      date: selectedDate ? selectedDate.toISOString().split("T")[0] : null,
      time: selectedTime ? selectedTime.toTimeString().split(" ")[0] : null,
      event,
      description,
    };

    const url = isEditing 
      ? `https://backend.skpandco.in/schedule/update/${editId}`
      : "https://backend.skpandco.in/schedule/add";
    const method = isEditing ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert(`Event ${isEditing ? "updated" : "added"} successfully!`);
        resetForm();
        fetchSchedules();
      } else {
        alert(`Failed to ${isEditing ? "update" : "add"} event.`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form.");
    }
  };

  return (
    <div className="Admincontrol" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      <div className="schedule-form" style={{ width: "50%", minWidth: "350px", background: "white", padding: "30px", borderRadius: "10px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
        <h3>{isEditing ? "Edit Schedule" : "Add New Schedule"}</h3>
        <form onSubmit={handleSubmit}>
          <label htmlFor="date">Date</label>
          <div className="input-with-icon">
            <DatePicker
              selected={selectedDate}
              onChange={setSelectedDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select date"
              className="date-picker-input"
              calendarClassName="custom-calendar"
              wrapperClassName="date-picker-wrapper"
            />
          </div>
          <label htmlFor="time">Time</label>
          <div className="input-with-icon">
            <DatePicker
              selected={selectedTime}
              onChange={setSelectedTime}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              placeholderText="Select time"
              className="date-picker-input"
              calendarClassName="custom-time-picker"
              wrapperClassName="date-picker-wrapper"
            />
          </div>
          <label htmlFor="event">Event</label>
          <input
            type="text"
            id="event"
            value={event}
            placeholder="Enter event name"
            onChange={(e) => setEvent(e.target.value)}
            style={{ width: "100%", padding: "10px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ddd" }}
          />
          <label htmlFor="description">Event Description</label>
          <textarea
            id="description"
            value={description}
            placeholder="Enter event description"
            onChange={(e) => setDescription(e.target.value)}
            style={{ width: "100%", padding: "10px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ddd", minHeight: "80px" }}
          />
          <button type="submit" style={{ width: "100%", padding: "12px", background: "#000", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" }}>
             {isEditing ? "Update Event" : "Add Event"}
          </button>
          {isEditing && (
            <button 
              type="button" 
              onClick={resetForm}
              style={{ width: "100%", padding: "12px", background: "#888", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold", marginTop: "10px" }}
            >
              Cancel Edit
            </button>
          )}
        </form>
      </div>

      <div className="schedule-list" style={{ width: "90%", marginTop: "40px" }}>
        <h3>Scheduled Meetings</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "25px" }}>
          {schedules.map((schedule) => (
            <div key={schedule.id} className="schedule-item">
              <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>{schedule.event}</h4>
              <p style={{ margin: "5px 0" }}><strong>Date:</strong> {schedule.date ? new Date(schedule.date).toLocaleDateString() : 'N/A'}</p>
              <p style={{ margin: "5px 0" }}><strong>Time:</strong> {schedule.time}</p>
              <p style={{ margin: "5px 0", fontSize: "0.9em", color: "#666" }}><strong>Description:</strong> {schedule.description}</p>
              <div className="item-actions">
                <button 
                  className="edit-btn"
                  onClick={() => handleEdit(schedule)}
                >
                  Edit
                </button>
                <button 
                  className="delete-btn"
                  onClick={() => handleDelete(schedule.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminSchedule;
